import { render, staticRenderFns } from "./cust-detail.vue?vue&type=template&id=cfd565ac&scoped=true"
import script from "./cust-detail.vue?vue&type=script&lang=js"
export * from "./cust-detail.vue?vue&type=script&lang=js"
import style0 from "./cust-detail.vue?vue&type=style&index=0&id=cfd565ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd565ac",
  null
  
)

export default component.exports